import BuiltByAlumniFooter from '@components/profile/teacher/built-by-alumni-footer'
import TeacherAbout from '@components/profile/teacher/about'
import TeacherDetails from '@components/profile/teacher/details'
import TeacherLanguagesSpoken from '@components/profile/teacher/languages-spoken'
import TeacherMathematicalAreas from '@components/profile/teacher/mathematical-areas'
import TeacherProgrammingLanguages from '@components/profile/teacher/programming-languages'
import TeacherQualifications from '@components/profile/teacher/qualifications'
import TeacherSpeciality from '@components/profile/teacher/speciality'
import TeacherStats from '@components/profile/teacher/stats'
import TeacherTeachingExperience from '@components/profile/teacher/teaching-experience'
import TeacherThoughtsQuote from '@components/profile/teacher/thoughts-quote'
import TeacherVideo from '@components/profile/teacher/video'
import React from 'react'

const TeacherProfile = () => (
  <div className="bg-grey-100 p-5">
    <div className="max-w-5xl mx-auto mb-10 bg-white rounded-lg shadow-sm overflow-hidden">
      <TeacherDetails />
      <TeacherStats />
      <TeacherThoughtsQuote />
      <TeacherAbout />
      <TeacherVideo />
      <TeacherQualifications />
      <TeacherTeachingExperience />
      <TeacherSpeciality />
      <TeacherProgrammingLanguages />
      <TeacherMathematicalAreas />
      <TeacherLanguagesSpoken />
      <BuiltByAlumniFooter />
    </div>
  </div>
)

export default React.memo(TeacherProfile)
